import * as React from 'react'

import {
  Box,
  Card,
  RadioButton,
  Text,
  TogglerCheckbox,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { ExtraHoursBaselineOptions } from 'modules/attendance/store/models/AttendanceSetting'

export interface HoursTypeCardProps {
  title: string
  description: string
  referencePoint: string
  referencePointDescription: string
  showToggle?: boolean
  enabled: boolean
  onToggle?: (enabled: boolean) => void
  selectedBaseline: string
  onBaselineChange: (option: string) => void
  radioNamePrefix: string
}

const HoursTypeCard = ({
  title,
  description,
  referencePoint,
  referencePointDescription,
  showToggle = false,
  enabled,
  onToggle,
  selectedBaseline,
  onBaselineChange,
  radioNamePrefix,
}: HoursTypeCardProps) => {
  const { PLANNED_HOURS, CONTRACT_HOURS } = ExtraHoursBaselineOptions

  return (
    <Box
      flexDirection="column"
      gap="s8"
      background="grey200"
      padding="s24"
      borderRadius={{
        all: 'abs008',
      }}
    >
      <Box flexDirection="row" alignItems="flexStart" justifyContent="spaceBetween" gap="s16">
        <Box gap="s4" style={{ minWidth: '0' }}>
          <Text size="200" weight="semibold">
            {title}
          </Text>
          <Text size="200">{description}</Text>
        </Box>
        {showToggle && onToggle ? <TogglerCheckbox value={enabled} onChange={onToggle} /> : null}
      </Box>

      {enabled && (
        <Box gap="s4" paddingTop="s8">
          <Text size="200" weight="semibold">
            {referencePoint}
          </Text>
          <Text size="200">{referencePointDescription}</Text>
          <Box gap="s8" paddingTop="s8">
            <Card>
              <Card.Title
                size="small"
                action={
                  <RadioButton
                    size="medium"
                    name={`${radioNamePrefix}_planned_hours`}
                    onChange={() => onBaselineChange(PLANNED_HOURS)}
                    value={PLANNED_HOURS}
                    checked={selectedBaseline === PLANNED_HOURS}
                  />
                }
              >
                {i18n.t(
                  'time_tracking.settings.work_time_categories.extra_and_complementary_hours_calculation.common.planned_hours'
                )}
              </Card.Title>
              <Card.Description>
                {i18n.t(
                  'time_tracking.settings.work_time_categories.extra_hours_calculation.baseline.planned_hours_description'
                )}
              </Card.Description>
            </Card>
            <Card>
              <Card.Title
                size="small"
                action={
                  <RadioButton
                    size="medium"
                    name={`${radioNamePrefix}_agreement_hours`}
                    onChange={() => onBaselineChange(CONTRACT_HOURS)}
                    value={CONTRACT_HOURS}
                    checked={selectedBaseline === CONTRACT_HOURS}
                  />
                }
              >
                {i18n.t(
                  'time_tracking.settings.work_time_categories.extra_and_complementary_hours_calculation.common.agreement_hours'
                )}
              </Card.Title>
              <Card.Description>
                {i18n.t(
                  'time_tracking.settings.work_time_categories.extra_hours_calculation.baseline.agreement_hours_description'
                )}
              </Card.Description>
            </Card>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default HoursTypeCard
